export default "__VITE_ASSET__DM2BCCFL__"